import { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import ProductCard from "@/components/ProductCard";
import { api } from "@/lib/api";

const CATEGORIES = ["All", "Serums", "Scalp Care", "Nourishment"];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api
      .get("/products", { params: cat === "All" ? {} : { category: cat } })
      .then((r) => setProducts(r.data))
      .catch(() => {});
  }, [cat]);

  return (
    <div className="pt-32 md:pt-40 pb-24 bg-cream min-h-screen" data-testid="shop-page">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <Reveal>
          <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber-deep">The Shop</span>
          <h1 className="mt-5 font-serif text-5xl md:text-7xl leading-[0.9] text-obsidian">
            Clinical &amp; herbal<br /><span className="italic">essentials.</span>
          </h1>
        </Reveal>

        <div className="mt-12 flex flex-wrap gap-3 border-b border-black/10 pb-6">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setCat(c)}
              className={`px-5 py-2 font-sans uppercase tracking-[0.2em] text-[11px] border transition-colors ${
                cat === c
                  ? "bg-obsidian text-cream border-obsidian"
                  : "border-black/15 text-obsidian/70 hover:border-obsidian"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {products.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
        {products.length === 0 && (
          <p className="mt-10 font-sans text-obsidian/50">No products in this category.</p>
        )}
      </div>
    </div>
  );
}
